import { ReactElement } from 'react';

import { HeadingProps } from './types';

import VStack from '../Stacks/VStack';

export default function Heading(props: HeadingProps): ReactElement {
  const { renderCaption, renderTitle, renderSubtitle, spacing = 1, ...rest } = props;

  return (
    <VStack {...rest} alignItems='flex-start' justifyContent='center' spacing={spacing}>
      {renderCaption
        ? renderCaption({
            align: 'left',
            color: 'primary',
            textTransform: 'uppercase',
            variant: 'subtitle1'
          })
        : null}
      {renderTitle({ align: 'left', color: 'textPrimary', variant: 'h4' })}
      {renderSubtitle
        ? renderSubtitle({ align: 'left', color: 'textSecondary', variant: 'body1' })
        : null}
    </VStack>
  );
}
